import React from 'react';
import { HeroBanner } from '../../components/HeroBanner/HeroBanner';
import RichText from '../../util/RichText';

const HeroBannerWrapper = ({ bannerContent, opacity }) => {
  let bannerDetails = {};

  const getValue = bannerContent => {
    if (bannerContent?.length) {
      bannerContent.map(ele => {
        switch (ele?.sys?.contentType?.sys?.id) {
          case 'imageBlock':
            if (ele?.fields?.type === 'background') {
              bannerDetails['backgroundImage'] = ele.fields?.imagePath || ele.fields?.image?.fields?.file?.url;
              bannerDetails['mobileBackgroundImage'] =
                ele.fields?.mobileImagePath || ele.fields?.mobileImage?.fields?.file?.url;
            } else {
              bannerDetails['logo'] = ele?.fields?.image?.fields?.file?.url;
            }
            break;

          case 'textBlockWithMobile': {
            bannerDetails['title'] = ele.fields.title;
            bannerDetails['subTitle'] = ele?.fields?.content ? RichText(ele.fields.content) : null;
            break;
          }
          default: {
            return null;
          }
        }
      });
    } else if (
      bannerContent?.image ||
      bannerContent?.imagePath ||
      bannerContent?.mobileImage ||
      bannerContent?.mobileImagePath
    ) {
      if (bannerContent?.type === 'background') {
        bannerDetails['backgroundImage'] = bannerContent?.imagePath || bannerContent?.image?.fields?.file?.url;
        bannerDetails['mobileBackgroundImage'] =
          bannerContent?.mobileImagePath || bannerContent?.mobileImage?.fields?.file?.url;
      }
    }
  };
  getValue(bannerContent);

  return (
    <div className="hero-banner-print-class">
      {bannerDetails && (
        <HeroBanner
          bannerTitle={bannerDetails?.title}
          bannerText={bannerDetails?.subTitle}
          bannerImage={bannerDetails?.backgroundImage}
          bannerLogo={bannerDetails?.logo}
          bannerMobileImage={bannerDetails?.mobileBackgroundImage}
          opacity={opacity}
        />
      )}
    </div>
  );
};

export { HeroBannerWrapper };
